import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Shared tab strip for pages that are one destination in the sidebar but two
// routes in code — Email | SMS inbox, Support enquiries | Returns, Reviews |
// Customer feedback — and for the Customer CRM's own tabs. Navigation only:
// each page keeps its own data, queries and actions.
export default function AdminSectionTabs({ tabs, className = '' }) {
  const { pathname } = useLocation();

  return (
    <div className={`flex items-center gap-1 overflow-x-auto border-b border-white/5 ${className}`}>
      {tabs.map((t) => {
        // A tab can also claim sibling routes, so a deep link still lights the
        // view it belongs to.
        const active =
          pathname === t.to ||
          (t.match || []).some((m) => pathname === m || pathname.startsWith(m + '/'));
        return (
          <Link
            key={t.to}
            to={t.to}
            className={`px-4 py-3 text-[10px] font-bold tracking-widest whitespace-nowrap border-b-2 -mb-px transition-colors ${
              active
                ? 'border-primary text-primary'
                : 'border-transparent text-white/40 hover:text-white'
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}